import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { PagesType } from "../../types/enum/pagesType";
import { PageContentType } from "../../types/modules/admin/pageContent.type";

export const usePagesContentAdmin = (pageType: PagesType) => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["pages-by-admin", pageType],
    queryFn: () => fetcher<PageContentType>(`page/admin/${pageType}`, token),
  });
};
